import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  color?: string;
}

export const Root = styled.div`
  display: flex;
  flex-direction: column;
`

export const LayerNameContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
  color: ${C.WHITE};
  background-color: ${C.DARK_BLUE};
  padding: 5px;
  margin: 5px 0px 0px 0px;
  border-radius: 5px;
`

export const LayerName = styled.div`
  font-family: Roboto;
  font-size: 14px;
  padding: 0px 10px 0px 0px;
  flex: 1;
  overflow: hidden;
`

export const OptionsContainer = styled.div`
  display: flex;
  align-items: center;
`

export const LayerPreview = styled.img`
  width: 25px;
  height: 25px;
  object-fit: contain;
  margin: 0px 5px 0px 0px;
  background-image: linear-gradient(45deg, #808080 25%, transparent 25%), linear-gradient(-45deg, #808080 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #808080 75%), linear-gradient(-45deg, transparent 75%, #808080 75%);
  background-size: 4px 4px;
  background-position: 0 0, 0 2px, 2px -2px, -2px 0px;
`

export const HideButton = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 15px;
  opacity: 0.7;
  cursor: pointer;
  background-color: ${(props: IRootProps) => (props.color ? props.color : 'green')};
`

export const TextLayer = styled.div`
  font-size: 12px;
  color: ${C.GENERIC_GRAY}
`

export const ChildrenContainer = styled.div`
  padding: 0px 0px 0px 15px;
`
